export default class targetBlank {
  static exec() {
    const els = document.querySelectorAll('a');
    const isExternal = (href) => {
      return href.indexOf(location.hostname) === -1;
    };
    const isPdf = (href) => {
      return href.indexOf('.pdf') !== -1;
    };
    els.forEach(function (el) {
      if (isExternal(el.href) || isPdf(el.href)) {
        el.setAttribute('target', '_blank');
      }
    });
  }
}
